import React from 'react'
import styled from 'styled-components'
import { Modal } from 'antd'
import doctorImageSrc from 'src/assets/images/common/doctor-image.png'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PATH as AUTOMATIC_PLAN_PATH } from 'src/pages/automaticPlan'
import { PATH as PATH_AUTH } from 'src/pages/auth'
import LocalStorage from 'src/utils/LocalStorage'
import { useAppSelector } from 'src/store'

interface PrecautionModalProps {
  isOpen: boolean
  onClose?: () => void
}

const PrecautionModalOnline: React.FC<PrecautionModalProps> = ({ isOpen }) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const menuId = searchParams.get('menuId')
  const authInfo = useAppSelector((state) => state.ui.app.authInfo)

  const handleOkClick = () => {
    LocalStorage.setTelemedicine('false')
    if (authInfo) {
      return navigate(
        `${AUTOMATIC_PLAN_PATH.QUESTIONS.replace(
          ':id',
          menuId || '',
        )}?${searchParams.toString()}`,
      )
    }

    navigate(
      `${PATH_AUTH.REGISTER.replace(
        ':id',
        menuId || '',
      )}?${searchParams.toString()}`,
    )
  }

  return (
    <Modal
      open={isOpen}
      centered
      closable={false}
      footer={null}
      className="precaution-modal"
    >
      <Container>
        <DoctorImage src={doctorImageSrc} alt="doctor" />
        <Title>
          本サービスでは、問診回答結果をもとにお
          <br />
          客様に合ったプランをご提案いたします。
          <br />
          あなたのお悩みを解決する、ピッタリのお
          <br />
          薬に出会うため、問診にご回答ください。
        </Title>
        <Description>
          ※診察方法は、医師の判断により、必要に応じ
          <br />
          てビデオ通話、チャット、録画映像の送付、ま
          <br />
          たは電話等の多様な情報収集手段を用いる場合
          <br />
          があります。
        </Description>
        <OkButton onClick={handleOkClick}>OK</OkButton>
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  text-align: center;
  padding: 16px;
`

const DoctorImage = styled.img`
  width: 120px;
  height: auto;
  margin-bottom: 16px;
`

const Title = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`

const Description = styled.p`
  font-size: 12px;
  color: #333;
  text-align: justify;
  margin-bottom: 20px;
  line-height: 1.5;
  text-align: center;
`

const OkButton = styled.button`
  background-color: #00c853;
  border: none;
  padding: 3px 30px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  border-radius: 20px;
  cursor: pointer;
`

export default PrecautionModalOnline
